import { adminClient } from "./admin";

export const getQuoteSettings = async () =>
  (await adminClient().get("/admin/quote-settings")).data;

export const patchQuoteSettings = async (patch) =>
  (await adminClient().patch("/admin/quote-settings", patch)).data;

export const listQuotePapers = async () =>
  (await adminClient().get("/admin/internal-quote/papers")).data;

export const calculateQuote = async (payload) =>
  (await adminClient().post("/admin/internal-quote/calculate", payload)).data;
